const announcement = document.getElementById('visitor-coverage-announcement');
// One key for every page, so the announcement shows at most once per tab session.
const sessionKey = 'visitorCoverageAnnouncementShown';

if (announcement && typeof announcement.showModal === 'function') {
    let shown = false;
    let triggerTimer;
    let retryTimer;

    try {
        shown = window.sessionStorage.getItem(sessionKey) === 'true';
    } catch (error) {
        // Storage can be disabled; still show at most once on this page.
    }

    function stopTriggers() {
        window.clearTimeout(triggerTimer);
        window.clearTimeout(retryTimer);
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('load', start);
    }

    function loadImages() {
        announcement.querySelectorAll('img[data-src]').forEach(img => {
            if (!img.src) img.src = img.dataset.src;
        });
    }

    function showAnnouncement() {
        if (shown) return;

        const anotherModalOpen = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], .c-Modal, .c-app-share'))
            .some(modal => modal !== announcement && modal.getClientRects().length > 0 && window.getComputedStyle(modal).visibility !== 'hidden');

        // Wait until the tab is visible.
        if (document.hidden) {
            document.addEventListener('visibilitychange', showAnnouncement, { once: true });
            return;
        }

        // Wait until any existing dialog has closed.
        if (anotherModalOpen) {
            window.clearTimeout(retryTimer);
            retryTimer = window.setTimeout(showAnnouncement, 500);
            return;
        }

        loadImages();
        announcement.showModal();
        document.documentElement.classList.add('has-visitor-announcement');
        shown = true;
        stopTriggers();
        try {
            window.sessionStorage.setItem(sessionKey, 'true');
        } catch (error) {
            // Dismissal and page-level suppression also work without storage.
        }
    }

    function onScroll() {
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollableHeight > 0 && window.scrollY / scrollableHeight >= 0.3) {
            showAnnouncement();
        }
    }

    function start() {
        // Fetch the decorative assets after page load so they do not compete with the hero.
        loadImages();

        const navigation = window.performance.getEntriesByType('navigation')[0];
        const elapsedSinceLoad = navigation && navigation.loadEventEnd > 0
            ? window.performance.now() - navigation.loadEventEnd : 0;
        triggerTimer = window.setTimeout(showAnnouncement, Math.max(0, 15000 - elapsedSinceLoad)); // 15 seconds
    }

    announcement.querySelectorAll('[data-announcement-dismiss], .c-Visitor-announcement__cta').forEach(control => {
        control.addEventListener('click', () => announcement.close());
    });
    announcement.addEventListener('close', () => {
        document.documentElement.classList.remove('has-visitor-announcement');
    });

    // Native modal dialogs keep focus inside, support Escape, and restore prior focus on close.
    if (!shown) {
        window.addEventListener('scroll', onScroll, { passive: true });
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, { once: true });
    }
}
